<template>
  <div
    v-if="copyVideoInfo != null"
    class="edit-form wrapperModal"
  >
    <!-- Edit tabs -->
    <edit-tools-bar
      :modal-sourse-list="modalSourseList"
      :media-cuts="mediaCuts"
      :selected="selectedOption"
      :is-edit-loading="isEditing"
      :is-edit-disabled="!areEditingParamsValid"
      :prosentage-drag-end-drop="prosentageDragEndDrop"
      :disabled-btn-save-edits="disabledBtnSaveEdits"
      @selectedOption="selectedOption = $event"
      @edit="openModalAddInfo"
    />
    <sharing-form
      v-if="modalSharingSocials"
      :id="this.newVideoIdMultiEdit"
      :multistep-id="this.multiStepIdSocials"
      :clip-duration="clipDuration"
      :visible="modalSharingSocials"
      :sharing-in-studio="true"
      @closed="modalSharingSocials = false"
    />
    <!-- Modal descrioptions-->
    <modal
      v-show="modalDescriptions"
      :title="titleModalDescriptions"
      :visible="modalDescriptions"
      :can-close="true"
      class="watch-modal positin-modal"
      @close="closeModalDescriptions"
    >
      <template v-slot:body>
        <modal-add-descriptions
          :stream="stream"
          :channels="channels"
          :disabledbutton="disabledbutton"
          :disabled-save-btn="disabledSaveBtn"
          :video-id="videoInfoID"
          :new-generate-video="progressNewGenerateVideo"
          :all-time-new-video="allTimeNewVideo"
          @valueChangeStream="valueChangeStream = $event"
          @targetChannelId="targetChannelId = $event"
          @changeDisabledSaveBtn="disabledSaveBtn = $event"
          @changeDisabledbutton="disabledbutton = $event"
          @shangeFlagOpenModalMM="sharingToMMforStudio"
          @shangeFlagOpenModalSosials="sharingToSocialsStudio"
          @startEdit="handleEditing"
          @closeModal="closeModalDescriptions"
        />
      </template>
    </modal>
    <div class="wrapper">
      <div class="wrapper-left">
        <!-- Video Player -->
        <el-row
          class="edit-form__player edit-player"
          type="flex"
          justify="start"
        >
          <div ref="editContainer" class="edit-player__container">
            <edit-player
              ref="editPlayer"
              v-model="playerData"
              :mode="mode"
              :status-mode="mode"
              :src="newVideoDistribution"
              :thumbnail="
                hasSudioMode === 'studioVideoEdit'
                  ? copyVideoInfo.thumbnailLink
                  : poster
              "
              :is-muted.sync="soundData.mutePlayer"
              :video-sizes="cropVideoResize ? videoSizeCrop : videoSizes"
              :crop-video-resize="cropVideoResize"
              :player-time="changesPlayerTime"
              :player-start-time="playerStartTime"
              :paused="playerPaused"
              @timeUpdate="playerTime = $event"
              @updatePausedTrue="playerPaused = $event"
              @updatePausedFalse="playerPaused = $event"
            />
            <!-- <div
              v-if="cropResizePreview"
              :style="{
                width: cropWidth + 'px',
                height: cropHeight + 'px',
                overflow: 'hidden'
              }"
            > -->
            <!--
            <wrapper-crop-edit-player
              v-if="cropResizePreview"
              ref="editPlayer"
              v-model="playerData"
              :mode="mode"
              :scale="scale"
              :player-size="playerSize"
              :crop-x="cropX"
              :crop-y="cropY"
              :crop-width="cropWidth"
              :crop-height="cropHeight"
              :status-mode="mode"
              :src="newVideoDistribution"
              :thumbnail="copyVideoInfo.thumbnailLink"
              :is-muted.sync="soundData.mutePlayer"
              :video-sizes="cropVideoResize ? videoSizeCrop : videoSizes"
              :crop-video-resize="cropVideoResize"
              :player-time="changesPlayerTime"
              :player-start-time="playerStartTime"
              :paused="playerPaused"
              @timeUpdate="playerTime = $event"
              @updatePausedTrue="playerPaused = $event"
              @updatePausedFalse="playerPaused = $event"
            />
            -->
            <!-- </div> -->

            <!-- Crop draggable area -->
            <crop-area
              v-if="enabledSettings.crop && showCropArea"
              class="edit-player__area"
              :red-flag="redFlag"
              :x.sync="cropX"
              :y.sync="cropY"
              :width.sync="cropWidth"
              :height.sync="cropHeight"
              :aspect-ratio="cropAspectRatio"
              :style="{
                'pointer-events': selectedOption == 'crop' ? 'all' : 'none'
              }"
              :key="playerSize.width + 'x' + playerSize.height"
            />

            <!-- Text draggable area -->
            <text-area
              v-if="enabledSettings.text && showTextArea"
              class="edit-player__area"
              :placement.sync="textPlacement"
              :drag-mode-text="dragModeText"
              :text="textData.text"
              :size="scaledTextSize"
              :font="textData.font"
              :color="textData.color"
              :style="{
                'pointer-events': selectedOption == 'text' ? 'all' : 'none'
              }"
              @textOverlapped="textFit = false"
              @textFit="textFit = true"
            />

            <!-- Image draggable area -->
            <template-area
              v-if="enabledSettings.templates && templateImage"
              class="edit-player__area"
              :scaled-template-size="scaledTemplateSize"
              :position="templatePosition"
              :image="templateImage"
              :image-init="templateImage != null"
              :max-width="templateMaxWidth"
              :max-height="templateMaxHeight"
              :style="{
                'pointer-events': selectedOption == 'templates' ? 'all' : 'none'
              }"
              @resize="handleTemplateResize"
              @move="handleTemplateMove"
            />
          </div>
        </el-row>

        <!-- Edit parameters -->
        <el-row class="edit-form__params edit-params">
          <!-- Crop video -->
          <edit-crop-panel
            v-show="selectedOption == 'crop'"
            class="edit-params__panel edit-crop-panel"
            :crop-aspect-ratio.sync="cropAspectRatio"
            :is-crop-added="enabledSettings.crop"
            :mode="mode"
            @stopPreview="handleStopPreview"
            @addCrop="enabledSettings.crop = true"
            @removeCrop="enabledSettings.crop = false"
          />

          <!-- Audio mixing -->
          <edit-sound-panel
            v-show="selectedOption == 'audio'"
            class="edit-params__panel edit-sound-panel"
            :video-time="playerData.time"
            :video-paused="playerData.paused"
            :video-loading="playerData.loading"
            :max-duration="playerData.duration"
            :muted="soundData.mutePlayer"
            :sound-on="enabledSettings.audio"
            :size-limit-m-b="$options.maxFileSize"
            @muteVideo="soundData.mutePlayer = true"
            @unmuteVideo="soundData.mutePlayer = false"
            @fileUploaded="soundData.file = $event"
            @soundMoved="soundData.start = $event"
            @enableSound="enabledSettings.audio = true"
            @disableSound="enabledSettings.audio = false"
          />

          <!-- Overlay text -->
          <edit-text-panel
            v-show="selectedOption == 'text'"
            ref="editTextPanel"
            v-model="textData"
            class="edit-params__panel edit-text-panel"
            :video-duration="sheckRangesDurations"
            :text-fit="textFit"
            :is-text-added="enabledSettings.text"
            @updateTimeline="textTimeline = convertTimeline($event)"
            @enableText="enabledSettings.text = true"
            @disableText="enabledSettings.text = false"
          />

          <!-- Overlay image -->
          <edit-template-panel
            v-show="selectedOption == 'templates'"
            v-model="preloadTemplateImage"
            class="edit-params__panel edit-template-panel"
            :position-preset.sync="templatePreset"
            :size-limit-m-b="$options.maxFileSize"
            @imageFileUploaded="templateFile = $event"
            @addTemplate="enabledSettings.templates = true"
            @removeTemplate="enabledSettings.templates = false"
          />

          <!-- Overlay cut -->
          <!---->
          <edit-cut-panel
            v-show="selectedOption == 'cut'"
            :video-info="copyVideoInfo"
            :selected-source-video-id="selectedSourceVideoId"
            :video-duration="newDurationVideo"
            :video-src="newVideoDistribution"
            :video-distribution="videoDistribution"
            :mode="mode"
            @cut="cutVideo($event)"
            @selectMode="changeSelectMode"
            @playerTime="newPlayerTime = $event"
            @startPreview="startPreview"
            @playerPaused="playerPausedEmit = $event"
            @stopPreview="handleStopPreview"
          />
          <!---->
        </el-row>
      </div>
      <div class="wrapper-right">
        <el-row>
          <sources-panel
            :stream-display-name="
              this.streamDisplayName ? this.streamDisplayName : ''
            "
            :selected-source-video-id="selectedSourceVideoId"
            :video-info="copyVideoInfo"
            :media-items-list="mediaItemsList"
            :thumbnail-link="thumbnail"
            :is-updating-thumbnail="isUpdatingThumbnail"
            :duration-clip="newDurationVideo"
            :stream="stream"
            :selected="selectedOption"
            :is-edit-loading="isEditing"
            :is-edit-disabled="!areEditingParamsValid"
            :select-id-video="selectIdVideo"
            :thumbs="thumbs"
            :select-video-uploading-id="videoUploadingId"
            :prosentage-drag-end-drop="this.prosentageDragEndDrop"
            @videoSelected="handleVideoSelect"
            @renewThumbnail="newThumbnail"
            @selectedOption="selectedOption = $event"
            @edit="handleEditing"
            @openModalSelect="openModal"
            @changeCutMode="selectModeCut"
            @openModalUpload="openModalUploadFile"
          />
        </el-row>
        <el-row>
          <media-edit-list
            v-model="mediaCuts"
            class="list"
            lock-axis="y"
            :transition-duration="10"
            :distance="20"
            :lock-offset="90"
            :hide-sortable-ghost="true"
            :use-window-as-scroll-container="true"
            :video-info="videoInfo"
            @removeVideoIndex="removeVideoInIndex"
            @previewRange="selectVideoPreview($event, true)"
            @selectVideoId="mediaListId = $event"
          />
        </el-row>
      </div>
      <div></div>
      <el-dialog
        :visible="isShowVideoModal"
        :before-close="closeModalSelectVideoItem"
        title="Select video file"
        custom-class="modalSelect"
        append-to-body
      >
        <modal-video-items
          class="modalSelect"
          :media-items="mediaItemsList"
          :media-tab="mediaTab"
          :video-id="copyVideoInfo.id"
          :selected-items="selectedItemsSet"
          :clear-checkbox="clearCheckbox"
          @shoceId="selectId"
          @saveDataVideo="saveModalSelectVideoItem"
        />
      </el-dialog>
      <el-dialog
        :visible="isShowVideoModalVideoUpload"
        :before-close="closeModalVideoUpload"
        title="Uploading media"
        custom-class="modalSelect modalUploadMedia"
        append-to-body
      >
        <modal-video-upload
          ref="clearFile"
          class="modalSelect wrapper-modal-upload"
          @uploadingProcessing="dragEndDropProcent"
          @closeModal="timeOutCloseModalVideoUpload"
          @selectIdUploading="videoUploadingId = $event"
        />
      </el-dialog>
      <!-- <el-dialog
        :visible="previewModalOpen"
        :align-center="true"
        :before-close="closePreviewModal"
        custom-class="preview-modal"
        title="Preview"
        append-to-body
      > -->
      <modal
        v-show="previewModalOpen"
        title="Preview"
        class="preview-modal"
        :visible="previewModalOpen"
        :can-close="true"
        @close="closePreviewModal"
      >
        <template v-slot:body>
          <crop-preview-player
              ref="previewPlayer"
              :mode="mode"
              :player-size="playerSize"
              :crop-x="cropXRatio"
              :crop-y="cropYRatio"
              :crop-width="cropWidthRatio"
              :crop-height="cropHeightRatio"
              :status-mode="mode"
              :src="previewSource"
              :thumbnail="copyVideoInfo.thumbnailLink"
              :is-muted="soundData.mutePlayer"
              :video-sizes="cropVideoResize ? videoSizeCrop : videoSizes"
              :crop-video-resize="cropVideoResize"
              :cut-start="previewCutRange[0]"
              :cut-end="previewCutRange[1]"

              :textOverlay="{
                'enabled': enabledSettings.text && showTextArea,
                'text': textData.text,
                'font': textData.font,
                'color': textData.color,
                'size': textData.size,
                'x': textXRatio,
                'y': textYRatio
              }"

              :imageOverlay="{
                'enabled': enabledSettings.templates && templateImage,
                'src': templateImage ? templateImage.src : null,
                'x': templateXRatio,
                'y': templateYRatio,
                'width': templateWidthRatio,
                'height': templateHeightRatio
              }"
            />
        </template>
      </modal>
      <!-- </el-dialog> -->
    </div>
    <!--
    <edit-cut-panel
      v-show="selectedOption == 'cut'"
      :video-info="copyVideoInfo"
      :selected-source-video-id="selectedSourceVideoId"
      :video-duration="newDurationVideo"
      :video-src="newVideoDistribution"
      :video-distribution="videoDistribution"
      :mode="mode"
      @cut="cutVideo($event)"
      @selectMode="changeSelectMode"
      @playerTime="newPlayerTime = $event"
      @startPreview="startPreview"
      @playerPaused="playerPausedEmit = $event"
      @preview="startPreviewMode = $event"
      @stopPreview="handleStopPreview"
    />
    -->
    <div class="btnPolicy">
      <a href="https://www.mangomolo.com/privacy" target="_blank" class="btnPolicyItem"
        >Privacy Policy</a
      >
      <div>|</div>
      <a href="https://www.mangomolo.com/contact" target="_blank" class="btnPolicyItem"
        >Contact Us</a
      >
    </div>
    <!-- Modal forms -->
    <modals-manager />
  </div>
</template>

<script>
import EditToolsBar from "@/components/media/editing/EditToolsBar.vue";
import EditPlayer from "@/components/media/editing/EditPlayer.vue";
import WrapperCropEditPlayer from "@/components/media/editing/WrapperCropEditPlayer.vue";
import CropPreviewPlayer from "@/components/media/editing/CropPreviewPlayer.vue";
// Panels
import EditSoundPanel from "@/components/media/editing/EditSoundPanel.vue";
import EditCropPanel from "@/components/media/editing/EditCropPanel.vue";
import EditTextPanel from "@/components/media/editing/EditTextPanel.vue";
import EditTemplatePanel from "@/components/media/editing/EditTemplatePanel.vue";
import EditCutPanel from "@/components/media/editing/EditCutPanel.vue";
// Overlay areas
import CropArea from "@/components/areas/CropArea.vue";
import TextArea from "@/components/areas/TextArea.vue";
import TemplateArea from "@/components/areas/TemplateArea.vue";

import SourcesPanel from "@/components/media/editing/SourcesPanel.vue";
import MediaEditList from "@/components/media/editing/MediaEditList.vue";
import ModalVideoItems from "@/components/media/editing/ModalVideoItems.vue";
import ModalVideoUpload from "@/components/media/editing/ModalVideoUpload.vue";
import ModalAddDescriptions from "@/components/media/editing/ModalAddDescriptions.vue";
// import SharingFromMangomolo from "@/components/socials/share/SharingFromMangomolo.vue";
import getVideos from "@/api/media/videos.js";

import "vue-slider-component/theme/default.css";

import { multiEdit } from "@/api/edit.js";
import { multiEditAudio } from "@/api/editAudio.js";

import { maxFileSize } from "@/api/params.js";
import { getAPI, token } from "@/api/params.js";

import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import mediaApi from "@/api/media/media.js";
import { MEDIA_CONVERSION_STATUS } from "@/constants.js";
import fallbackImage from "@/assets/images/empty.jpg";
import { getVideoById } from "@/api/media/videos.js";
import { getAudioById } from "@/api/media/audios.js";
import { getUserData } from "@/api/auth.js";
import { uploadFile } from "@/api/fileUpload.js";
import Modal from "@/components/dialog/Modal.vue";
import SharingForm from "@/components/socials/share/SharingForm.vue";
import { getByChannel } from "@/api/streams.js";
import { getStringSizes } from "@/utils/text.js";
import { mediaSourceTimeToResultTime, roundToMilliseconds } from "@/utils/time.js";
import { setFontsPath } from "@/api/fonts.js";
import defaultAudioPoster from "@/assets/images/audio_channel_default.jpg";
/** modals manager */
import ModalsManager from "@/components/dialog/ModalsManager.vue";

import { MODES_DRAG, MODES_PREVIEW } from "./cut_modes";
import {
  BOTTOM_LEFT_PRESET,
  BOTTOM_PRESET,
  CENTER_PRESET,
  LEFT_PRESET,
  NONE_PRESET,
  RIGHT_PRESET,
  TOP_LEFT_PRESET,
  TOP_PRESET,
  TOP_RIGHT_PRESET
} from "./template_presets.js";

// @group Editing
// Edit video panel component
export default {
  name: "EditVideoForm",
  components: {
    ModalAddDescriptions,
    Modal,
    ModalVideoItems,
    ModalVideoUpload,
    EditToolsBar,
    EditPlayer,
    /*VideoPlayer,*/
    CropArea,
    TextArea,
    TemplateArea,
    // Panels
    EditSoundPanel,
    EditCropPanel,
    EditTextPanel,
    EditTemplatePanel,
    SourcesPanel,
    MediaEditList,
    EditCutPanel,
    // SharingFromMangomolo,
    SharingForm,
    // WrapperCropEditPlayer,
    CropPreviewPlayer,
    ModalsManager
    // defaultAudioPoster
  },
  props: {
    currentChannel: {
      type: Number,
      default: 0
    },
    audioFlagFromClipper: {
      type: Boolean,
      default: false
    },
    mmVideoId: {
      type: [Number, Array],
      default: null
    },
    mmAudioId: {
      type: [Number, Array],
      default: null
    },
    videoInfoID: {
      type: Number,
      default: 0
    },
    app: {
      type: String,
      default: ""
    },
    vod: {
      type: String,
      default: ""
    },
    host: {
      type: String,
      default: ""
    },
    // is form shown
    // visible: {
    //   type: Boolean,
    //   required: true,
    //   default: true
    // },
    // videoSrc: {
    //   type: [Object, String],
    //   required: true
    // },
    thumbnail: {
      type: String
    },
    /** Wowza stream name */
    stream: {
      type: String,
      default: "No Stream"
    },
    /** is poster refreshing */
    isUpdatingThumbnail: {
      type: Boolean,
      default: false
    },
    /** Audio duration in seconds */
    duration: {
      type: Number,
      default: null
    },
    videoDistribution: {
      type: String
    },
    streamId: {
      type: String
    },

    mediaItemsLists: {
      type: Object,
      default() {
        return {
          clips: [],
          gifs: [],
          upload: [],
          audios: []
        };
      }
    }
  },
  data() {
    return {
      mediaListId: 0,
      mediaTab: "clips",
      videoInfo: null,
      prosentageDragEndDrop: 0,
      videoUploadingId: [],
      clearCheckbox: false,
      mediaItemsList: this.mediaItemsLists,
      currentRanges: [],
      copyVideoInfo: this.videoInfo,
      newDurationVideo: this.duration,
      // cutInfo: {},
      mediaCuts: [],
      newDownloadLink: "",
      selectedSourceVideoId: 0,
      modalSourseList: false,
      selectIdVideo: [],
      isShowVideoModal: false,
      isShowVideoModalVideoUpload: false,
      mode: "drag",
      // startPreviewEmit: 0,
      isEditing: false,
      selectedOption: "audio",
      playerStartTime: 0,
      newPlayerTime: 0,
      playerTime: 0,
      // startPreviewMode: "null",
      // stopPreview: false,
      playerData: {
        time: 0,
        paused: true,
        loading: true,
        duration: 10
      },
      playerSizeWatcher: null,
      playerSize: {
        width: 640,
        height: 360
      },
      enabledSettings: {
        crop: false,
        audio: false,
        text: false,
        templates: false
      },
      /** Preview player */
      previewModalOpen: false,
      previewCutRange: [0, 0],
      previewSourceId: null,
      /** Crop parameters */
      cropX: 0,
      cropY: 0,
      cropWidth: 50,
      cropHeight: 50,
      cropResizePreview: false,
      cropAspectRatio: 1,
      /** Sound parameters */
      soundData: {
        mutePlayer: false,
        start: 0,
        file: null
      },
      /** Text parameters */
      textPlacement: {
        x: 0,
        y: 0
      },
      copyTextPlacement: {
        x: 0,
        y: 0
      },
      textTimeline: {
        start: 0,
        end: Infinity
      },
      textData: {
        text: "Test",
        font: "Arial",
        size: 18,
        color: "#ffffff"
      },
      textFit: true,
      /** Template parameters */
      templateImage: null,
      preloadTemplateImage: null,
      templatePreset: NONE_PRESET,
      templateFile: null,
      templatePosition: {
        x: 0,
        y: 0
      },
      copyTemplatePosition: {
        x: 0,
        y: 0
      },
      templateSize: null,
      stopPreviewWatch: null,
      playerPaused: true,
      // mmTokenVideoId: null,
      modalDescriptions: false,
      titleModalDescriptions: "Add info for video",
      modalSharingSocials: false,
      modalSharingMM: false,
      newVideoIdMultiEdit: null,
      multiStepIdSocials: null,
      titleModalStudioForMM: "",
      titleArabModalStudioForMM: "",
      descriptionModalDescriptions: "",
      idShareMMStudio: this.videoInfoID,
      // newVideoEdit: null,
      sharingResp: [],
      cropVideoResize: false,
      showCropArea: true,
      dragModeText: true,
      disabledbutton: false,
      disabledSaveBtn: false,
      disabledBtnSaveEdits: false,
      redFlag: false,
      channels: [],
      // videosList: [],
      valueChangeStream: "",
      targetChannelId: 0,
      // selectModals: "",
      urlFont: ""
    };
  },
  computed: {
    ...mapGetters(["hasSudioMode", "channelType"]),
    ...mapState({
      /** stream info */
      thumbs: state => state.services.thumbs,
      poster: state => state.services.channelPoster
    }),
    streamDisplayName() {
      return this.channels.filter(
        e => e.default_stream == this.videoInfo.stream
      )[0]?.display_name;
    },
    progressNewGenerateVideo() {
      return this.channelType === "audio"
        ? this.mediaItemsList.audios.filter(
            e => e.id === this.newVideoIdMultiEdit
          )
        : this.mediaItemsList.clips.filter(
            e => e.id === this.newVideoIdMultiEdit
          );
      // return this.mediaItemsList.clips.filter(
      //   e => e.id === this.newVideoIdMultiEdit
      // );
    },
    allTimeNewVideo() {
      return this.mediaCuts.reduce((acc, cut) => {
        const difference = cut.ranges.map(range => range[1] - range[0]);
        return acc + difference.reduce((sum, val) => sum + val, 0);
      }, 0);
    },
    statusVideoEdit() {
      return this.mediaItemsList.clips.filter(
        e => e.id === this.newVideoIdMultiEdit
      )[0]?.status;
    },
    textSizes() {
      return getStringSizes(
        this.textData.text,
        this.textData.font,
        this.scaledTextSize
      );
    },
    // @vuese
    // Duration of clip in seconds
    clipDuration() {
      // If metadata not loaded (video is converting), then time is not set
      return this.videoInfo.metadata?.duration;
    },
    thumbnailLink: {
      cache: false,
      get() {
        return this.videoInfo.status == MEDIA_CONVERSION_STATUS.READY
          ? `${this.videoInfo.storageUrl}/${this.info.thumbnailLink}`
          : fallbackImage;
      }
    },
    sheckRangesDurations() {
      return this.mediaCuts.reduce((sum, x) => {
        if (!x) return sum;
        return (
          sum +
          x.ranges.reduce((sum, x) => {
            return sum + (x[1] - x[0]);
          }, 0)
        );
      }, 0);
    },
    newVideoDistribution() {
      const videoDistribution = {
        type: "video/mp4",
        src: this.addNewDownloadLink
      };
      const audioDistribution = {
        type: "audio/mp3",
        src: this.addNewDownloadLink
      };
      return this.channelType === "audio"
        ? audioDistribution
        : videoDistribution;
      // return { type: "video/mp4", src: this.addNewDownloadLink };
    },
    previewSource() {
      if(this.previewSourceId) {
        const videoInfo = this.mediaItemsList.clips.find(v => v.id === this.previewSourceId);
        const downloadLink = videoInfo ? videoInfo.downloadLink : '';
        return {
          type: this.channelType === "audio" ? "audio/mp3" : "video/mp4",
          src: downloadLink
        };
      }
      return { type: "video/mp4", src: '' };
    },
    addNewDownloadLink() {
      return this.videoInfo.status === MEDIA_CONVERSION_STATUS.READY ||
        this.videoInfo.status === MEDIA_CONVERSION_STATUS.REMOTE
        ? `${this.newDownloadLink}`
        : null;
    },
    selectedItemsSet: function() {
      return new Set(this.selectIdVideo);
    },
    changesPlayerTime() {
      return this.newPlayerTime;
    },
    cropcropHeightForVideoPlayer() {
      return this.cropHeight;
    },
    cropWidthForVideoPlayer() {
      return this.cropWidth;
    },
    // @vuese
    // Original video width in pixels
    videoWidth() {
      return this.videoInfo.metadata?.width || 1920;
    },
    // @vuese
    // Original video height in pixels
    videoHeight() {
      return this.videoInfo.metadata?.height || 1080;
    },
    // @vuese
    // Video duration in seconds
    videoDuration() {
      return (
        this.videoInfo.metadata?.duration ||
        this.videoInfo.endTime - this.videoInfo.startTime
      );
    },
    newScale: function() {
      if (this.cropHeight > this.cropWidth)
        return this.playerSize.height / this.cropHeight;
      else return this.playerSize.width / this.cropWidth;
    },
    viewportScale() {
      if (!this.cropWidth || !this.cropHeight) return 1;
      const realCropWidth = this.cropWidth * this.newScale;
      const realCropHeight = this.cropHeight * this.newScale;
      return Math.min(
        1,
        this.playerSize.width / realCropWidth,
        this.playerSize.height / realCropHeight
      );
    },
    // @vuese
    // Actual player size divided by original video size
    scale() {
      if (this.cropResizePreview == true) {
        return (this.playerSize.width / this.videoWidth) * this.newScale;
      }
      return this.playerSize.width / this.videoWidth;
    },
    // @vuese
    // Scale text font size to player sizes
    scaledTextSize() {
      return this.textData.size * this.scale;
    },
    scaledTemplateSize() {
      /*
      if (!this.dragModeText) {
        return this.newScale * this.viewportScale;
      }
      return 1;
      */
      return this.scale;
    },
    // @vuese
    // Rounded up video duration (in seconds)
    //shange clip duration at new
    ceiledClipDuration() {
      return roundToMilliseconds(this.videoDuration);
    },
    // @vuese
    // Is player time in text timeline borders
    showTextArea() {
      /*
      const time = Math.round(this.playerData.time * 10) / 10;
      return time >= this.textTimeline.start && time <= this.textTimeline.end;
      */
      const ranges = this.mediaCuts.map((cut) => cut.ranges[0]);
      const resultTime = mediaSourceTimeToResultTime(this.playerData.time, ranges);
      return resultTime != null &&
        resultTime >= this.textTimeline.start &&
        resultTime <= this.textTimeline.end;
    },
    videoSizeCrop() {
      return {
        width: this.cropWidthForVideoPlayer,
        height: this.cropcropHeightForVideoPlayer
      };
    },
    // @vuese
    // Original video width and height
    videoSizes() {
      return {
        width: this.videoWidth,
        height: this.videoHeight
      };
    },
    // @vuese
    // Scale player crop area coords and sizes to original video scal
    descaledCropPlacement() {
      return this.descaleRectangle({
        x: this.cropX,
        y: this.cropY,
        width: this.cropWidth,
        height: this.cropHeight
      });
    },
    // @vuese
    // Crop X position as ratio to video width (0-1)
    // Returns 0 when crop is disabled
    cropXRatio() {
      if (!this.enabledSettings.crop || !this.videoWidth) {
        return 0;
      }
      const descaled = this.descaledCropPlacement;
      return Math.max(0, Math.min(1, descaled.x / this.videoWidth));
    },
    // @vuese
    // Crop Y position as ratio to video height (0-1)
    // Returns 0 when crop is disabled
    cropYRatio() {
      if (!this.enabledSettings.crop || !this.videoHeight) {
        return 0;
      }
      const descaled = this.descaledCropPlacement;
      return Math.max(0, Math.min(1, descaled.y / this.videoHeight));
    },
    // @vuese
    // Crop width as ratio to video width (0-1)
    // Returns 1 when crop is disabled
    cropWidthRatio() {
      if (!this.enabledSettings.crop || !this.videoWidth) {
        return 1;
      }
      const descaled = this.descaledCropPlacement;
      return Math.max(0, Math.min(1, descaled.width / this.videoWidth));
    },
    // @vuese
    // Crop height as ratio to video height (0-1)
    // Returns 1 when crop is disabled
    cropHeightRatio() {
      if (!this.enabledSettings.crop || !this.videoHeight) {
        return 1;
      }
      const descaled = this.descaledCropPlacement;
      return Math.max(0, Math.min(1, descaled.height / this.videoHeight));
    },
    // @vuese
    // Scale player image placement coords and sizes to original video scale
    descaledTemplatePlacement() {
      return this.descaleRectangle({
        ...this.templatePosition,
        ...this.templateSize
      });
    },
    // @vuese
    // Scale player text placement coords and sizes to original video scale
    descaledTextPlacement() {
      return {
        x: this.descaleCoord(this.textPlacement.x),
        y: this.descaleCoord(this.textPlacement.y)
      };
    },
    // @vuese
    // Text X position as ratio to video width (0-1)
    // Returns 0 when text is disabled or video size is unknown
    textXRatio() {
      if (!this.enabledSettings.text || !this.videoWidth) {
        return 0;
      }
      const descaled = this.descaledTextPlacement;
      return Math.max(0, Math.min(1, descaled.x / this.videoWidth));
    },
    // @vuese
    // Text Y position as ratio to video height (0-1)
    // Returns 0 when text is disabled or video size is unknown
    textYRatio() {
      if (!this.enabledSettings.text || !this.videoHeight) {
        return 0;
      }
      const descaled = this.descaledTextPlacement;
      return Math.max(0, Math.min(1, descaled.y / this.videoHeight));
    },
    // @vuese
    // Text width as ratio to video width (0-1)
    // Returns 0 when text is disabled or video size is unknown
    textWidthRatio() {
      if (!this.enabledSettings.text || !this.videoWidth) {
        return 0;
      }
      // textSizes.width — ширина текста в координатах плеера
      const textWidthVideo = this.convertToVideoWidth(this.textSizes.width);
      return Math.max(0, Math.min(1, textWidthVideo / this.videoWidth));
    },
    // @vuese
    // Text height as ratio to video height (0-1)
    // Returns 0 when text is disabled or video size is unknown
    textHeightRatio() {
      if (!this.enabledSettings.text || !this.videoHeight) {
        return 0;
      }
      // textSizes.height — высота текста в координатах плеера
      const textHeightVideo = this.convertToVideoHeight(this.textSizes.height);
      return Math.max(0, Math.min(1, textHeightVideo / this.videoHeight));
    },
    templateOriginSizes() {
      if (!this.templateImage) {
        return {
          width: 0,
          height: 0
        };
      }

      const { naturalWidth: width, naturalHeight: height } = this.templateImage;
      return {
        width,
        height
      };
    },
    // @vuese
    // Template X position as ratio to video width (0-1)
    // Returns 0 when template is disabled or video size is unknown
    templateXRatio() {
      if (!this.enabledSettings.templates || !this.videoWidth || !this.templateSize) {
        return 0;
      }
      const descaled = this.descaledTemplatePlacement;
      return Math.max(0, Math.min(1, descaled.x / this.videoWidth));
    },
    // @vuese
    // Template Y position as ratio to video height (0-1)
    // Returns 0 when template is disabled or video size is unknown
    templateYRatio() {
      if (!this.enabledSettings.templates || !this.videoHeight || !this.templateSize) {
        return 0;
      }
      const descaled = this.descaledTemplatePlacement;
      return Math.max(0, Math.min(1, descaled.y / this.videoHeight));
    },
    // @vuese
    // Template width as ratio to video width (0-1)
    // Returns 0 when template is disabled or video size is unknown
    templateWidthRatio() {
      if (!this.enabledSettings.templates || !this.videoWidth || !this.templateSize) {
        return 0;
      }
      const descaled = this.descaledTemplatePlacement;
      return Math.max(0, Math.min(1, descaled.width / this.videoWidth));
    },
    // @vuese
    // Template height as ratio to video height (0-1)
    // Returns 0 when template is disabled or video size is unknown
    templateHeightRatio() {
      if (!this.enabledSettings.templates || !this.videoHeight || !this.templateSize) {
        return 0;
      }
      const descaled = this.descaledTemplatePlacement;
      return Math.max(0, Math.min(1, descaled.height / this.videoHeight));
    },
    // @vuese
    // Original template image width as ratio to video width (0-1)
    // Returns 0 when template image is not loaded or video size is unknown
    templateImageWidthRatio() {
      if (!this.templateImage || !this.videoWidth) {
        return 0;
      }
      const originSizes = this.templateOriginSizes;
      return Math.max(0, Math.min(1, originSizes.width / this.videoWidth));
    },
    // @vuese
    // Original template image height as ratio to video height (0-1)
    // Returns 0 when template image is not loaded or video size is unknown
    templateImageHeightRatio() {
      if (!this.templateImage || !this.videoHeight) {
        return 0;
      }
      const originSizes = this.templateOriginSizes;
      return Math.max(0, Math.min(1, originSizes.height / this.videoHeight));
    },
    // @vuese
    // Max width for image template in pixels
    templateMaxWidth() {
      if (!this.templateOriginSizes.width) return this.playerSize.width;

      const scaledWidth = this.templateOriginSizes.width * this.scale;
      const playerWidth = this.playerSize.width;

      return Math.min(scaledWidth, playerWidth);
    },
    // @vuese
    // Max height for image template in pixels
    templateMaxHeight() {
      if (!this.templateOriginSizes.height) return this.playerSize.height;

      const scaledHeight = this.templateOriginSizes.height * this.scale;
      const playerHeight = this.playerSize.height;
      return Math.min(scaledHeight, playerHeight);
    },
    // @vuese
    // Are all edit parameters off
    areEditingParamsEmpty() {
      return (
        !this.enabledSettings.crop &&
        !this.enabledSettings.text &&
        !this.enabledSettings.templates &&
        !this.enabledSettings.audio &&
        !this.soundData.mutePlayer
      );
    },
    // @vuese
    // Is text edit parameters valid for editing
    isTextValid() {
      return this.textFit && this.textData.text.length;
    },
    // @vuese
    // Are parameters valid to send edit request
    areEditingParamsValid() {
      return (
        (this.enabledSettings.text && this.isTextValid) ||
        (!this.enabledSettings.text && !this.areEditingParamsEmpty)
      );
    },

    
  },
  watch: {
    cropX() {
      if (this.enabledSettings.text) {
        if (
          this.textPlacement.x < this.cropX ||
          this.textPlacement.x >
            this.cropX + this.cropHeight - this.textSizes.width ||
          this.textPlacement.y < this.cropY ||
          this.textPlacement.y >
            this.cropY + this.cropWidth - this.textSizes.height
        ) {
          this.disabledBtnSaveEdits = true;
          this.redFlag = true;
        } else {
          this.redFlag = false;
          this.disabledBtnSaveEdits = false;
        }
      }
    },
    cropY() {
      if (this.enabledSettings.text) {
        if (
          this.textPlacement.x < this.cropX ||
          this.textPlacement.x >
            this.cropX + this.cropHeight - this.textSizes.width ||
          this.textPlacement.y < this.cropY ||
          this.textPlacement.y >
            this.cropY + this.cropWidth - this.textSizes.height
        ) {
          this.disabledBtnSaveEdits = true;
          this.redFlag = true;
        } else {
          this.redFlag = false;
          this.disabledBtnSaveEdits = false;
        }
      }
    },
    textPlacement() {
      if (this.enabledSettings.crop && this.enabledSettings.text) {
        if (
          this.textPlacement.x < this.cropX ||
          this.textPlacement.x > this.cropX + this.cropHeight ||
          this.textPlacement.y < this.cropY ||
          this.textPlacement.y > this.cropY + this.cropWidth
        ) {
          this.disabledBtnSaveEdits = true;
          this.redFlag = true;
        } else {
          this.redFlag = false;
          this.disabledBtnSaveEdits = false;
        }
      }
    },
    cropResizePreview() {
      if (this.cropResizePreview) {
        this.dragModeText = false;
      } else {
        this.dragModeText = true;
      }
    },
    selectedSourceVideoId() {
      if (this.selectedSourceVideoId != 0) {
        if (this.channelType === "audio") {
          this.copyVideoInfo = this.mediaItemsList.audios.find(
            e => e.id == this.selectedSourceVideoId
          );
        } else {
          this.copyVideoInfo = this.mediaItemsList.clips.find(
            e => e.id == this.selectedSourceVideoId
          );
        }
        this.newDurationVideo = this.copyVideoInfo.metadata.duration;
        this.newDownloadLink = this.copyVideoInfo.downloadLink;
        this.videoInfo = this.copyVideoInfo;
        
        if(this.cropResizePreview) {
          this.playerPaused = true;
          this.playerStartTime = 0;
          this.$refs.editPlayer.setTime(0);
          this.mode = MODES_DRAG;
          if (typeof this.stopPreviewWatch == `function`) {
            this.stopPreviewWatch();
          }
        }
      }
    },
    statusVideoEdit() {
      if (this.statusVideoEdit == "failed") {
        this.showError("Editing completed with an error, repeat later");
      }
    },
    // urlFont(){
    //   if(this.urlFont !== ''){
    //     setFontsPath(this.urlFont + "/fonts");
    //   } else {
    //     setFontsPath(this.videoInfo.storageUrl + "/fonts");
    //   }
    // },
    mediaListId() {
      this.selectedSourceVideoId = this.mediaListId;
    },
    newDurationVideo() {
      this.$emit("newDurationVideo", this.newDurationVideo);
    },
    newDownloadLink() {
      this.$emit("newDownloadLink", this.copyVideoInfo.downloadLink);
    },
    mode() {
      if (this.mode == "preview") {
        this.copyTextPlacement = {
          x: this.textPlacement.x,
          y: this.textPlacement.y
        };
        this.copyTemplatePosition = {
          x: this.templatePosition.x,
          y: this.templatePosition.y
        };
        this.playerPaused = false;
        this.showCropArea = false;

        if (this.cropResizePreview === true) {
          this.textPlacement = {
            x: (this.textPlacement.x - this.cropX) * this.newScale * this.viewportScale,
            y: (this.textPlacement.y - this.cropY) * this.newScale * this.viewportScale
          };
          this.templatePosition = {
            x: (this.templatePosition.x - this.cropX) * this.newScale * this.viewportScale,
            y: (this.templatePosition.y - this.cropY) * this.newScale * this.viewportScale
          };
        }
      } else {
        this.textPlacement = {
          x: this.copyTextPlacement.x,
          y: this.copyTextPlacement.y
        };
        this.templatePosition = {
          x: this.copyTemplatePosition.x,
          y: this.copyTemplatePosition.y
        };
        // this.templatePosition = {
        //   x: 0,
        //   y: 0
        // };

        // this.$nextTick(() => {
        //   this.templatePosition = {
        //     x: this.copyTemplatePosition.x,
        //     y: this.copyTemplatePosition.y
        //   };
        // });

        // this.$nextTick(() => {
        //   this.templatePosition = {
        //     x: 0,
        //     y: 0
        //   };
        // });

        this.cropResizePreview = false;
        this.showCropArea = true;
      }
    },
    // @vuese
    // Move image when user select position preset
    templatePreset() {
      if (this.templateImage) {
        this.moveTemplateToPreset();
      }
    },
    // @vuese
    // Update image width & height
    preloadTemplateImage() {
      if (!this.preloadTemplateImage) {
        this.templateImage = null;
        this.templateSize = null;
        return;
      }

      /** we update origin template sizes on load to update max template sizes */
      this.preloadTemplateImage.onload = () => {
        this.templateImage = this.preloadTemplateImage;
        this.preloadTemplateImage.onload = null;
      };
    },
    // @vuese
    // Move template to preset when size inited
    templateSize(newSize, oldSize) {
      if (oldSize === null) {
        this.moveTemplateToPreset();
      }
    }
  },
  async created() {
    this.setStudioVideoMode({ data: true });
    const channelId = await this.$route.query.channel_id;
    if (channelId != undefined) {
      if (this.stream == "No Stream") {
        const streamInfoByChannel = await getByChannel(
          this.$route.query.channel_id
        );
        this.stream = streamInfoByChannel.stream;
      }
    }
    // this.getAllVideos();
  },
  async mounted() {
    this.showLoading();
    try {
      const resp = await getUserData();
      if (
        resp.features.mango_studio === "0" &&
        this.$route.name === "Mangomolo studio"
      ) {
        throw Error(
          "There are no access rights to the studio, please contact technical support."
        );
      } else {
        this.channels = resp.channels;
        this.initializeUserData({
          userData: resp,
          channelId: Number(this.currentChannel)
        });
      }
      // Load videos from Mangomolo if mm_video_id is provided
      if (this.mmVideoId) {
        this.setUpdateShannelType("video");
        // Normalize to array - handle both single value and array
        // Also handle the case where parseQuery converts numbers
        let videoIds;
        if (Array.isArray(this.mmVideoId)) {
          // Create a new array to avoid read-only property issues
          videoIds = this.mmVideoId.map(id => id);
        } else {
          videoIds = [this.mmVideoId];
        }

        // Convert all to numbers and remove duplicates
        const uniqueVideoIds = [...new Set(videoIds.map(id => Number(id)).filter(id => !isNaN(id)))];

        // Load all videos in parallel
        const videoPromises = uniqueVideoIds.map(async (mmVideoId) => {
          try {
            // Build URL with stream parameter if available
            const streamParam = this.stream && this.stream !== "No Stream" 
              ? `&stream=${encodeURIComponent(this.stream)}` 
              : "";
            const response = await fetch(
              `${getAPI()}/mangomolo/get_mm_video?token=${token}&mm_video_id=${mmVideoId}${streamParam}`
            );
            if (response.ok) {
              const resp = await response.json();
              return { success: true, data: resp.data, mmVideoId };
            } else {
              const errorText = await response.text();
              return {
                success: false,
                error: `HTTP ${response.status}: ${errorText}`,
                mmVideoId
              };
            }
          } catch (error) {
            return {
              success: false,
              error: error.message,
              mmVideoId
            };
          }
        });

        const videoResults = await Promise.all(videoPromises);

        // Process successful loads
        let firstSuccessfulVideo = null;
        let loadedCount = 0;

        videoResults.forEach((result) => {
          if (result.success && result.data?.id) {
            this.selectIdVideo.push(result.data.id);
            loadedCount++;

            // Use first successful video for initialization
            if (!firstSuccessfulVideo) {
              firstSuccessfulVideo = result.data;
            }
          } else {
            // Show error for failed loads
            this.showError(
              "Video Load Failed",
              `Failed to load Mangomolo video ID ${result.mmVideoId}: ${result.error || 'Unknown error'}`
            );
          }
        });

        // Set videoInfo from first successful video if available
        if (firstSuccessfulVideo) {
          this.videoInfo = firstSuccessfulVideo;
          
          // Update stream from videoInfo if returned by API and not set
          if (firstSuccessfulVideo.stream && 
              (this.stream === "No Stream" || !this.stream)) {
            this.stream = firstSuccessfulVideo.stream;
          }
        }

        // Initialize fonts from first successful video
        if (firstSuccessfulVideo && firstSuccessfulVideo.storageUrl) {
          this.urlFont = firstSuccessfulVideo.storageUrl + "/fonts";
          setFontsPath(this.urlFont);
          // Initialize fonts after component is ready
          this.$nextTick(() => {
            if (this.$refs.editTextPanel) {
              this.$refs.editTextPanel.initFonts();
            }
          });
        }

        // Show success notification if any videos loaded
        if (loadedCount > 0) {
          if (loadedCount < uniqueVideoIds.length) {
            this.showSuccess(
              "Videos Loaded",
              `Successfully loaded ${loadedCount} of ${uniqueVideoIds.length} video(s)`
            );
          }
        } else {
          throw new Error("Failed to load any videos from Mangomolo");
        }
      } else if (this.mmAudioId) {
        this.setUpdateShannelType("audio");
        // Normalize to array - handle both single value and array
        // Also handle the case where parseQuery converts numbers
        let audioIds;
        if (Array.isArray(this.mmAudioId)) {
          // Create a new array to avoid read-only property issues
          audioIds = this.mmAudioId.map(id => id);
        } else {
          audioIds = [this.mmAudioId];
        }

        // Convert all to numbers and remove duplicates
        const uniqueAudioIds = [...new Set(audioIds.map(id => Number(id)).filter(id => !isNaN(id)))];

        // Load all audios in parallel
        const audioPromises = uniqueAudioIds.map(async (mmAudioId) => {
          try {
            // Build URL with stream parameter if available
            const streamParam = this.stream && this.stream !== "No Stream" 
              ? `&stream=${encodeURIComponent(this.stream)}` 
              : "";
            const response = await fetch(
              `${getAPI()}/mangomolo/get_mm_audio?token=${token}&mm_audio_id=${mmAudioId}${streamParam}`
            );
            if (response.ok) {
              const resp = await response.json();
              return { success: true, data: resp.data, mmAudioId };
            } else {
              const errorText = await response.text();
              return {
                success: false,
                error: `HTTP ${response.status}: ${errorText}`,
                mmAudioId
              };
            }
          } catch (error) {
            return {
              success: false,
              error: error.message,
              mmAudioId
            };
          }
        });

        const audioResults = await Promise.all(audioPromises);

        // Process successful loads
        let firstSuccessfulAudio = null;
        let loadedCount = 0;

        audioResults.forEach((result) => {
          if (result.success && result.data?.id) {
            this.selectIdVideo.push(result.data.id);
            loadedCount++;

            // Use first successful audio
            if (!firstSuccessfulAudio) {
              firstSuccessfulAudio = result.data;
            }
          } else {
            // Show error for failed loads
            this.showError(
              "Audio Load Failed",
              `Failed to load Mangomolo audio ID ${result.mmAudioId}: ${result.error || 'Unknown error'}`
            );
          }
        });

        // Set videoInfo from first successful audio if available
        if (firstSuccessfulAudio) {
          this.videoInfo = firstSuccessfulAudio;
          
          // Update stream from videoInfo if returned by API and not set
          if (firstSuccessfulAudio.stream && 
              (this.stream === "No Stream" || !this.stream)) {
            this.stream = firstSuccessfulAudio.stream;
          }
        }

        // Show success notification if any audios loaded
        if (loadedCount > 0) {
          if (loadedCount < uniqueAudioIds.length) {
            this.showSuccess(
              "Audios Loaded",
              `Successfully loaded ${loadedCount} of ${uniqueAudioIds.length} audio(s)`
            );
          }
        } else {
          throw new Error("Failed to load any audios from Mangomolo");
        }
      }

      // Set store edit mode
      if (this.channelType === "video") {
        this.$store.commit("updateStudioEdit", "studioVideoEdit");
      }
      if (this.channelType === "audio") {
        this.$store.commit("updateStudioEdit", "studioAudioEdit");
      }

      // Initialize videoInfo if not set from Mangomolo
      if (!this.videoInfo) {
        if (this.channelType === "video") {
          // If we have loaded videos from Mangomolo, use first one
          if (this.selectIdVideo.length > 0 && this.videoInfoID === 0) {
            this.videoInfo = await getVideoById(this.selectIdVideo[0]);
          } else if (this.videoInfoID !== 0) {
            this.videoInfo = await getVideoById(this.videoInfoID);
          } else {
            throw new Error("No video ID provided");
          }
        } else {
          // For audio, use first loaded ID or videoInfoID
          const audioId = this.selectIdVideo.length > 0 && this.videoInfoID === 0
            ? this.selectIdVideo[0]
            : this.videoInfoID;

          if (audioId === 0 && this.selectIdVideo.length === 0) {
            throw new Error("No audio ID provided");
          }

          if (audioId !== 0) {
            this.videoInfo = await getAudioById(audioId);
          }
        }
      }

      // Initialize fonts if not set from Mangomolo
      if (!this.urlFont && this.videoInfo?.storageUrl) {
        this.urlFont = this.videoInfo.storageUrl + "/fonts";
        setFontsPath(this.urlFont);
        this.$nextTick(() => {
          if (this.$refs.editTextPanel) {
            this.$refs.editTextPanel.initFonts();
          }
        });
      }

      // Ensure copyVideoInfo is set
      if (this.videoInfo) {
        this.copyVideoInfo = this.videoInfo;
      } else {
        throw new Error("Failed to initialize video information");
      }
      this.subscribeToAudios();
      this.subscribeToVideos();
      // this.getAllVideos()
      this.$nextTick(() => {
        const el = this.$refs.editContainer;
        if(!el) return;
        this.playerSizeWatcher = new ResizeObserver(() => {
          if(this.cropResizePreview) return;
          const oldPlayerSize = {
            width: this.playerSize.width,
            height: this.playerSize.height,
          }
          this.recalcPlayerSizes();
          const ratio = this.playerSize.width / oldPlayerSize.width;
          if(isNaN(ratio) || (ratio <= 0)) {
            console.warn(`Got incorrect ratio ${ratio} when adjusting crop window`);
            return;
          }
          this.cropWidth = ratio * this.cropWidth;
          this.cropHeight = ratio * this.cropHeight;
          this.cropX = ratio * this.cropX;
          this.cropY = ratio * this.cropY;
        });
        this.playerSizeWatcher.observe(el);
        this.recalcPlayerSizes();
      })
    } catch (e) {
      this.showCriticalError(`Clipper Error : ${e.message}`);
    } finally {
      this.hideLoading();
    }
  },
  beforeDestroy(){
    if(this.playerSizeWatcher) {
      this.playerSizeWatcher.disconnect();
      this.playerSizeWatcher = null;
    }
  },
  maxFileSize: maxFileSize,
  methods: {
    ...mapActions("socials", ["setSharing"]),
    ...mapActions({
      setStudioVideoMode: "setStudioVideoMode",
      setUpdateShannelType: "setUpdateShannelType"
    }),
    showLoading(message) {
      this.loadingInstance = this.$loading({
        lock: true,
        text: message,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 1)"
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    showCriticalError(message) {
      this.errorInstance = this.$loading({
        lock: true,
        text: message,
        spinner: "el-icon-warning-outline",
        background: "rgba(0, 0, 0, 1)"
      });
    },
    sharingToMM() {
      this.$emit(
        "shareToMMForStudio",
        this.titleModalStudioForMM,
        this.descriptionModalDescriptions,
        this.videoInfoID
      );
    },
    sharingToMMforStudio(titleEng, titleArab, descr, categoryId) {
      if (titleEng === "") {
        titleEng = this.stream;
      }

      if (descr === "") {
        descr = this.stream;
      }
      if (categoryId === null) {
        categoryId = this.videoInfoID;
      }
      this.titleModalStudioForMM = titleEng;
      this.titleArabModalStudioForMM = titleArab;
      this.descriptionModalDescriptions = descr;
      this.idShareMMStudio = categoryId;
      this.modalSharingMM = true;
    },
    sharingToSocialsStudio() {
      this.modalSharingSocials = true;
    },
    closeModalDescriptions() {
      this.disabledbutton = false;
      this.modalDescriptions = false;
      this.disabledSaveBtn = false;
    },
    dragEndDropProcent(prcentUploadDragEndDrop) {
      this.prosentageDragEndDrop = prcentUploadDragEndDrop;
    },
    // @vuese
    // Show error notification
    // @arg title - title text <br>
    // @arg text - message text
    showError(title, text) {
      this.$notify({
        group: "foo",
        type: "error",
        title: title,
        text: text
      });
    },
    // @vuese
    // Show success notification
    showSuccess(title, message) {
      this.$notify({
        group: "foo",
        position: "bottom right",
        type: "success",
        title: title,
        text: message
      });
    },
    ...mapActions("socials", ["setSharing"]),
    ...mapActions({
      initializeUserData: "initializeUserData"
    }),
    getAllVideos() {
      mediaApi.subscribeToVideoUpdates(
        this.app,
        "",
        videos => {
          this.mediaItemsList.clips = videos.slice();
        },
        e => {
          console.error(e);
          this.showError("Fetch Videos List Error", e);
        }
      );
    },
    getAllAudios() {
      mediaApi.subscribeToAudioUpdates(
        this.app,
        "",
        audios => {
          this.mediaItemsList.audios = audios.slice();
        },
        e => {
          console.error(e);
          this.showError("Fetch Videos List Error", e);
        }
      );
    },

    // @vuese
    // Enable videos updating
    subscribeToVideos() {
      mediaApi.subscribeToVideoUpdates(
        this.app,
        this.valueChangeStream !== this.stream ? "" : this.stream,
        videos => {
          this.mediaItemsList.clips = videos;
          // Update sharings data when video updated
          this.mediaItemsList.clips.forEach(v => {
            v.sharings.forEach(s =>
              this.setSharing({
                id: s.id,
                videoId: v.id,
                social: s.target,
                status: s.status,
                link: s.link ? s.link : null,
                percentage: s.percentage ? s.percentage : null,
                socialVideoId: s.socialVideoId,
                accountId: s.userSocialAccountId,
                publishTime: s.startPublishingTime
              })
            );
          });
        },
        e => {
          console.error(e);
          this.showError("Fetch Videos List Error", e);
        }
      );
    },
    subscribeToAudios() {
      mediaApi.subscribeToAudioUpdates(
        this.app,
        this.valueChangeStream !== this.stream ? "" : this.stream,
        audios => {
          this.mediaItemsList.audios = audios;
          this.mediaItemsList.audios.forEach(v => {
            v.sharings.forEach(s =>
              this.setSharing({
                id: s.id,
                videoId: v.id,
                social: s.target,
                status: s.status,
                link: s.link ? s.link : null,
                percentage: s.percentage ? s.percentage : null,
                socialVideoId: s.socialVideoId,
                accountId: s.userSocialAccountId,
                publishTime: s.startPublishingTime
              })
            );
          });
        },
        e => {
          console.error(e);
          this.showError("Fetch Videos List Error", e);
        }
      );
    },

    ...mapMutations(["setThumbs", "setHost", "setVod"]),
    changeSelectMode(event) {
      this.mode = event;
    },
    async cutVideo(event) {
      // this.cutInfo = event;
      if (!event.inverse) {
        const resp = await fetch(
          `${getAPI()}/video/${
            event.sourceId
          }/generate_thumbnails?token=${token}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(event.ranges.map(x => x[0]))
          }
        );
        const data = await resp.json();
        event.ranges.forEach(range => {
          this.mediaCuts.push({
            source: event.sourceId,
            ranges: [range],
            thumbnailLink: `${this.videoInfo.storageUrl}/videos/${data.data}/${Math.floor(range[0] * 1000)}.jpg`,
            type: "crop",
            title: event.title
          });
        });
      } else {
        const resp = await fetch(
          `${getAPI()}/video/${
            event.sourceId
          }/generate_thumbnails?token=${token}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(event.ranges.map(range => range[0]))
          }
        );
        const data = await resp.json();
        event.ranges.forEach(range => {
          this.mediaCuts.push({
            source: event.sourceId,
            ranges: [range],
            thumbnailLink: `${this.videoInfo.storageUrl}/videos/${data.data}/${Math.floor(range[0] * 1000)}.jpg`,
            type: "invcrop",
            title: event.title
          });
        });
      }
    },
    async selectVideoPreview({ range, index }, inPopup=false) {
      /*
      if (this.enabledSettings.crop === true) {
        this.cropResizePreview = true;
      } else {
        this.cropResizePreview = false;
      }
      this.mode = "preview";
      this.currentRanges = selectRange.slice();
      this.startPreviewCutVideo(selectRange[0]);
      */
      if(inPopup) {
      // Stop main player when opening preview dialog
        this.playerPaused = true;
        this.previewSourceId = this.mediaCuts[index].source;
        this.previewCutRange = range[0];
        this.previewModalOpen = true;
        this.$nextTick(() => {
          this.$refs.previewPlayer.startPreview(...range[0]);
        });
      } else {
        this.mode = "preview";
        this.currentRanges = range.slice();
        this.startPreviewCutVideo(range[0]);
      }
    },
    timeOutCloseModalVideoUpload() {
      setTimeout(() => this.closeModalVideoUpload(), 1000);
    },
    closeEditModal() {
      // this.handleStopPreview()
      this.selectedOption = "audio";
      this.playerPaused = true;
      this.mode = MODES_DRAG;
      this.mediaCuts = [];
      if (typeof this.stopPreviewWatch == `function`) {
        this.stopPreviewWatch();
      }
    },
    closePreviewModal() {
      // Stop preview playback before closing modal
      if (this.$refs.previewPlayer && typeof this.$refs.previewPlayer.stopPreview === 'function') {
        this.$refs.previewPlayer.stopPreview();
      }
      // Close preview modal
      this.previewModalOpen = false;
    },
    removeVideoInIndex(index) {
      if (index == this.mediaCuts.length - 1) this.mediaCuts.pop();
      else this.mediaCuts.splice(index, 1);
    },
    async startPreviewCutVideo([start, end]) {
      /*
      if (this.selectedOption == "crop") {
        this.cropVideoResize = true;
      } else {
        this.cropVideoResize = false;
      }
      */

      // setting time and waiting for video to load
      this.playerStartTime = start;

      await new Promise((res, rej) => {
        if (
          this.playerData.loading === false
        ) {
          return res();
        }
        let unwatch = null;
        unwatch = this.$watch('playerData', (playerData) => {
          if(
            playerData.loading === false
          ){
            unwatch();
            res();
          }
        });
        setTimeout(() => {
          unwatch();
          rej();
        }, 10000);
      })

      this.$refs.editPlayer.setTime(start);
      this.playerPaused = false;

      let firstPlayerData = true;
      if (typeof this.stopPreviewWatch == `function`) {
        this.stopPreviewWatch();
      }
      this.stopPreviewWatch = this.$watch("playerTime", () => {
        if (firstPlayerData) {
          firstPlayerData = false;
        }
        if (
          this.playerData.time < start ||
          this.playerData.time > end
        ) {
          console.warn("STOP!", this.playerData.time, start, end);
          this.playerPaused = true;
          this.playerStartTime = start;
          this.$refs.editPlayer.setTime(start);
          if (typeof this.stopPreviewWatch == `function`) {
            this.stopPreviewWatch();
          }
        }
      });
    },
    handleVideoSelect(videoId) {
      this.selectedSourceVideoId = videoId;
    },
    selectModeCut() {
      this.selectedOption = "cut";
    },
    selectId(idList) {
      this.selectIdVideo = Array.from(idList);
    },
    openModal() {
      this.isShowVideoModal = true;
      this.clearCheckbox = false;
    },
    openModalUploadFile() {
      this.isShowVideoModalVideoUpload = true;
    },
    // @vuese
    // Close panel
    close() {
      this.$emit("update:visible", false);
      // Panel closed by user
      this.$emit("closed");
      this.selectIdVideo = [];
      this.clearCheckbox = true;
      this.playerPaused = true;
    },
    closeModalSelectVideoItem() {
      this.isShowVideoModal = false;
      this.clearCheckbox = true;
      // Panel closed by user
      this.playerPaused = true;
    },
    closeModalVideoUpload() {
      this.isShowVideoModalVideoUpload = false;
    },
    saveModalSelectVideoItem() {
      this.isShowVideoModal = false;
      // Panel closed by user
      this.playerPaused = true;
    },
    startPreview([start, end]) {
      // let saveDuration = this.playerData.duration
      console.warn('startPreview', start, end)

      /*
      this.$refs.editPlayer.$refs.cutPlayer.durationVideoOffSet(start, end);

      this.$refs.editPlayer.setTime(0);
      this.playerPaused = false;
      this.mode = MODES_PREVIEW;
      */
      this.selectVideoPreview([[start, end]], false);

      // let firstPlayerData = true;
      // if (typeof this.stopPreviewWatch == `function`) {
      //   this.stopPreviewWatch();
      // }
      // this.stopPreviewWatch = this.$watch("playerTime", () => {
      //   if (firstPlayerData) {
      //     firstPlayerData = false;
      //   }
      //   if (this.playerData.time < start || this.playerData.time > end) {
      //     console.warn("STOP!", this.playerData.time, start, end);
      //     this.playerPaused = true;
      //     this.mode = MODES_DRAG;
      //     if (typeof this.stopPreviewWatch == `function`) {
      //       this.stopPreviewWatch();
      //     }
      //   }
      // });
    },
    handleStopPreview() {
      this.mode = MODES_DRAG;
      this.newPlayerTime = this.playerStartTime;
      this.playerPaused = true;
      if (typeof this.stopPreviewWatch == `function`) {
        this.stopPreviewWatch();
      }
    },
    // @vuese
    // Erase data
    resetData() {
      this.selectedOption = "audio";
      this.enabledSettings = {
        crop: false,
        audio: false,
        text: false,
        templates: false
      };
      /** Crop parameters */
      this.cropX = 0;
      this.cropY = 0;
      this.cropWidth = 50;
      this.cropHeight = 50;
      this.cropAspectRatio = 1;
      /** Sound parameters */
      this.soundData = {
        mutePlayer: false,
        start: 0,
        file: null
      };
      /** Text parameters */
      this.textPlacement = {
        x: 0,
        y: 0
      };
      this.textTimeline = {
        start: 0,
        end: this.ceiledClipDuration
      };
      this.textData = {
        text: "Test",
        font: "Arial",
        size: 18,
        color: "#ffffff"
      };
      /** Template parameters */
      this.templateImage = null;
      this.preloadTemplateImage = null;
      this.templateFile = null;
      this.templatePosition = {
        x: 0,
        y: 0
      };
    },
    newThumbnail() {
      this.$emit("renewThumbnail");
    },
    // @vuese
    // Update edit player width and height
    recalcPlayerSizes() {
      const rect = this.$refs.editContainer.getBoundingClientRect();
      if(rect.width < 1 || rect.height < 1) {
        // something weird is going on with player
        return;
      }
      this.playerSize.width = rect.width;
      this.playerSize.height = rect.height;
    },
    // @vuese
    // Parse edit response and show result
    handleRespStatus(status) {
      if (status.success) {
        this.$notify({
          group: "foo",
          type: "success",
          title: "Editing Started",
          text: "Video editing has started"
        });
        this.resetData();
        this.close();
      } else {
        this.$notify({
          group: "foo",
          type: "error",
          title: "Editing Failed",
          text: `Video editing has failed: ${status.error}`
        });
      }
    },
    openModalAddInfo() {
      if(this.stopPreviewWatch) {
        this.stopPreviewWatch();
      }
      this.cropResizePreview = false;
      this.modalDescriptions = true;
    },
    // @vuese
    // Edit video
    async handleEditing(
      deleteSourceBool,
      arabTitle,
      engTitle,
      descr,
      season,
      show,
      categoryId,
      targetStream,
      intro,
      outro,
      introStart,
      outroStart,
      caskaderIntroOutro,
      publish
    ) {
      // if (!this.areEditingParamsValid) {
      //   return;
      // }
      if (this.mediaCuts > 0) {
        return;
      }

      if (this.isEditing) {
        return;
      }

      const data = {
        cuts: this.mediaCuts
      };

      if (this.enabledSettings.crop) {
        data.crop = this.descaledCropPlacement;
      }

      if (this.enabledSettings.audio) {
        data.audio = this.soundData;
      } else if (this.soundData.mutePlayer) {
        data.audio = {
          mutePlayer: true
        };
      }

      if (this.enabledSettings.templates) {
        data.templates = {
          file: this.templateFile,
          ...this.descaledTemplatePlacement
        };
      }

      if (this.enabledSettings.text) {
        data.text = {
          ...this.textData,
          ...this.descaledTextPlacement,
          ...this.textTimeline
        };
      }
      if (this.modalSharingMM === true || this.modalSharingSocials === true) {
        data.multistepPartDto = {
          isFinalStep: true
        };
      }
      let status = {};
      this.isEditing = true;
      if (this.channelType === "video") {
        status = await multiEdit(
          this.videoInfo.id,
          { multistep: data },
          this.stream,
          deleteSourceBool,
          engTitle,
          arabTitle,
          descr,
          season,
          show,
          categoryId,
          targetStream,
          intro,
          outro,
          introStart,
          outroStart,
          caskaderIntroOutro
        );
      }
      if (this.channelType === "audio") {
        status = await multiEditAudio(
          this.videoInfo.id,
          { multistep: data },
          this.stream,
          deleteSourceBool,
          engTitle,
          arabTitle,
          descr,
          season,
          show,
          categoryId,
          targetStream
        );
      }

      if (status.success != false) {
        this.multiStepIdSocials = status.data.multistepId;
        this.newVideoIdMultiEdit = status.data.id;
      }

      if (this.modalSharingMM === true && status.success) {
        if (this.channelType === "audio") {
          this.sharingResp = await mediaApi.uploadToMangomoloAudio(
            status.data.id,
            this.newDownloadLink,
            this.titleModalStudioForMM,
            this.titleArabModalStudioForMM,
            this.descriptionModalDescriptions,
            this.valueChangeStream,
            this.idShareMMStudio,
            this.mmVideoId,
            status.data.multistepId,
            this.targetChannelId,
            publish
          );
        } else {
          this.sharingResp = await mediaApi.uploadToMangomolo(
            status.data.id,
            this.newDownloadLink,
            this.titleModalStudioForMM,
            this.titleArabModalStudioForMM,
            this.descriptionModalDescriptions,
            this.valueChangeStream,
            this.idShareMMStudio,
            this.mmVideoId,
            status.data.multistepId,
            this.targetChannelId,
            publish
          );
        }
      }
      this.isEditing = false;
      this.handleRespStatus(status);
      // this.modalDescriptions = false;
    },
    handleTemplateMove(newPosition) {
      this.resetPreset();
      this.templatePosition = newPosition;
    },
    handleTemplateResize(newSizes) {
      if (this.templateSize !== null) {
        /** there is no need to reset preset when size is initing */
        this.resetPreset();
      }
      this.templateSize = newSizes;
    },
    // @vuese
    // Move template to current preset position
    moveTemplateToPreset() {
      if (!this.templateImage) return;

      const preset = this.templatePreset;

      if (preset === NONE_PRESET) return;

      const height = this.playerSize.height;
      const width = this.playerSize.width;
      const imageHeight = this.templateSize.height;
      const imageWidth = this.templateSize.width;

      if ([TOP_LEFT_PRESET, TOP_PRESET, TOP_RIGHT_PRESET].includes(preset)) {
        /** move to top */
        this.templatePosition.y = 0;
      } else if ([LEFT_PRESET, CENTER_PRESET, RIGHT_PRESET].includes(preset)) {
        /** move to vertical center */
        const preferred = Math.floor((height - imageHeight) / 2);
        this.templatePosition.y = Math.max(preferred, 0);
      } else {
        /** move to bottom */
        this.templatePosition.y = Math.max(height - imageHeight, 0);
      }

      if ([TOP_LEFT_PRESET, LEFT_PRESET, BOTTOM_LEFT_PRESET].includes(preset)) {
        /** move to left */
        this.templatePosition.x = 0;
      } else if ([TOP_PRESET, CENTER_PRESET, BOTTOM_PRESET].includes(preset)) {
        /** move to horizontal center */
        const preferred = Math.floor((width - imageWidth) / 2);
        this.templatePosition.x = Math.max(preferred, 0);
      } else {
        /** move to right */
        this.templatePosition.x = Math.max(width - imageWidth, 0);
      }
    },
    resetPreset() {
      this.templatePreset = NONE_PRESET;
    },
    // @vuese
    // Scale rectangle coords and sizes to original video sizes
    descaleRectangle({ x, y, width, height }) {
      const descaledX = this.descaleCoord(x);
      const descaledY = this.descaleCoord(y);

      const descaledWidth = this.descaleSize(
        width,
        this.videoWidth - descaledX
      );
      const descaledHeight = this.descaleSize(
        height,
        this.videoHeight - descaledY
      );

      return {
        x: descaledX,
        y: descaledY,
        width: descaledWidth,
        height: descaledHeight
      };
    },
    // @vuese
    // Scale coord value to origin video sizes
    descaleCoord(coord) {
      return Math.max(Math.floor(coord / this.scale), 0);
    },
    // @vuese
    // Scale size value to origin video sizes
    descaleSize(size, maxDescaled) {
      return Math.min(Math.round(size / this.scale), maxDescaled);
    },
    // @vuese
    // Convert timeline from [0, 1] range to [0, video duration] range
    // @arg val - timeline array of two numbers
    convertTimeline(val) {
      return {
        start: val[0],
        end: val[1]
      };
    },
    getDescaled(val) {
      return Math.floor(val / this.scale);
    },
    convertToVideoHeight(height) {
      if (height == this.playerSize.height) {
        return this.videoHeight;
      }
      return this.getDescaled(height);
    },
    convertToVideoWidth(width) {
      if (width == this.playerSize.width) {
        return this.videoWidth;
      }
      return this.getDescaled(width);
    }
  }
};
</script>

<style lang="scss">
/*
.preview-modal.el-dialog {
  display: flex;
  flex-direction: column;
  min-height: auto;
  margin: auto !important;
}
.preview-modal .el-dialog__body {
  flex-grow: 1;
  padding: 0 0 30px;
}
*/
.preview-modal .modal {
  width: 100%;
  max-width: 960px;
}
</style>
<style lang="scss" scoped>
.watch-modal {
  z-index: 2004;
  position: absolute;
  // top: 20%;
  // left: 35%;
}

.positin-modal {
  position: fixed;
}

.edit-form__player {
  display: flex;
  justify-content: center;
}

.edit-form {
  &__player {
    overflow: hidden;
    max-width: 100%;
    margin: 0 auto;
    // flex-shrink: 0;
    // height: 70%;
  }
}

.edit-params {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  padding-top: 2em;

  &__panel {
    width: 100%;
  }
}

.edit-player {
  &__container {
    position: relative;
    max-height: 35vh; /* 100%; */
    width: 100%;
  }

  &__area {
    z-index: var(--edit-area-z);
  }
}
.watch-modal .modal {
  margin: 0 10px;
}
</style>

<style lang="scss">
.el-dialog__headerbtn {
  display: none;
}

.wrapperModal {
  width: 100%;
  background: #233d4e;
  // height: 100vh;
}

.el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #fff;
}

.modalSelect {
  z-index: 100000;
}

.wrapper {
  display: flex;
  overflow: hidden;
  flex-grow: 1;
}

.wrapper-left {
  display: flex;
  flex-direction: column;
  // max-width: 39vw;
  // min-width: 39vw;
  width: 65vw;
  height: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.wrapper-right {
  display: flex;
  flex-direction: column;
  margin: 0 0 0 25px;
  // width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}

/** param fields */
.params-col {
  display: flex;
  flex-direction: column;

  &__item:not(:last-child) {
    margin-bottom: 1.5em;
  }
}

.params-row {
  display: flex;

  &__item:not(:last-child) {
    margin-right: 1.5em;
  }

  &__grow-item {
    flex-grow: 1;
  }

  &_justify {
    &_center {
      justify-content: center;
    }
  }
}

.param-field {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__select {
    margin-top: 0.5em;
    margin-right: auto;
    margin-left: auto;

    max-width: 80px;
  }
}

.field-label {
  font-weight: bold;
}

/** input/select styling */
:-webkit-any(.edit-select, .edit-input) .el-input__inner {
  background-color: var(--dark-grey);
}

:-moz-any(.edit-select, .edit-input) .el-input__inner {
  background-color: var(--dark-grey);
}

:matches(.edit-select, .edit-input) .el-input__inner {
  background-color: var(--dark-grey);
}

/** form styles */
.el-dialog__body {
  padding-top: 0;
}

.el-dialog {
  /** width: fit-content; */
  padding: 0 2.5em;
  margin: 0 auto !important;
  min-height: 100%;
}

.modalUploadMedia {
  padding: 0px !important;
  margin: 0px auto !important;
  min-height: 100px !important;
}

.el-card__body {
  padding: inherit;
  width: 100%;
}
.edit-save-btn .el-loading-mask {
  background-color: transparent;
}

/** sized styles */
.edit-form {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #FFFFFF;
}

.edit-form {
  &__player {
    // height: 400px;
  }
}

.btnPolicy {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}

.btnPolicyItem {
  color: #fff;
  margin: 0 5px;
}

@media screen and (max-height: 850px) {
    .wrapper {
      overflow: clip;
    }

    .wrapper-right {
      margin: 0 -5px;
    }

    .edit-form {
      overflow: auto;
      // height: auto;
    }

    .edit-player__container {
      min-height: 35vh;
      max-height: none;
    }
} 

@media only screen and (max-width: 879px), only screen and (max-height: 600px) {
  .modalSelect {
    // height: 45% !important;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    /* overflow: hidden; */
  }
  .wrapper-right {
    padding: 10px 5px;
    margin: 0 -28px;
  }
  .wrapper-left {
    max-width: 100%;
    height: auto;
  }

  .el-dialog.edit-form {
    // width: 720px;
    // height: 101vh;
    // margin-top: 20px !important;
    // margin-bottom: 20px !important;
  }
  /*
  .edit-form {
    &__player {
      height: 300px;
    }
  }
  */
}
@media only screen and (max-width: 830px) {
  .wrapper {
    display: flex;
    flex-direction: column;
    overflow: visible;
  }
  .wrapper-left {
    overflow: visible;
  }
  .wrapper-right {
    padding: 10px 5px;
    margin: 0 -28px;
    overflow: visible;
  }

  .el-dialog.edit-form {
    // width: 720px;
    // height: 101vh;
    // margin-top: 20px !important;
    // margin-bottom: 20px !important;
  }
  .edit-form {
    overflow: scroll;
    

    &__player {
      height: 300px;
    }
  }
}

@media only screen and (max-width: 414px) {
  .wrapper-right {
    padding: 10px 5px;
    margin: 0 -28px;
  }
  .wrapper-left {
    max-width: 100%;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .modalSelect {
      // height: 55% !important;
    }
  }

  .el-dialog {
    width: 400px;
    // height: 95vh;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .edit-form {
    &__player {
      height: 200px;
    }
  }

  /** tabs styles */
  .tabs-row {
    &__tab {
      .material-design-icon .material-design-icon__svg {
        height: 1.5rem !important;
        width: 1.5rem !important;
      }
    }
  }

  .edit-tools {
    flex-direction: column;

    &__actions {
      margin-bottom: 15px;
    }
  }

  /** text edit panel styles */
  .edit-text-panel {
    .params-row {
      flex-wrap: wrap;
    }
    .params-row__item.text-field {
      width: 100%;
      // margin-right: 0;
      margin-bottom: 1.5em;
    }
  }
}

@media only screen and (max-width: 399px) {
  .el-dialog {
    width: calc(100% - 10px);
    height: auto;
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .edit-form {
    &__player {
      height: 192px;
      width: 342px;
    }
  }

  /** tabs styles */
  .edit-tools {
    font-size: 0.7rem;
  }

  .tabs-row {
    &__tab {
      .material-design-icon .material-design-icon__svg {
        height: 1.2rem !important;
        width: 1.2rem !important;
      }
    }
  }

  .save-text {
    font-size: 0.9rem;
  }

  /** player full size for mobile */
  .edit-player__container {
    width: 100%;
  }
  .edit-form-player {
    width: 100%;
  }
  .edit-player .vjs-tech {
    width: 100%;
  }

  /** text edit panel styles */
  .edit-text-panel {
    .params-row .params-row__item {
      width: 100%;
      // margin-right: 0;
      margin-bottom: 1.5em;
    }

    .edit-select {
      width: 100%;
    }
  }

  /** upload sound row */
  .edit-sound-panel {
    .upload-row {
      flex-wrap: wrap;
    }

    .upload-row .params-row__item {
      width: 100%;
      // margin-right: 0;
      margin-bottom: 1.5em;
    }
  }
}
</style>
